export function initVideoPlayer(parent) {
  if (!parent) return;

  const player = parent.querySelector('media-player');
  const play = parent.querySelector('.video-player__play');

  play.addEventListener('click', () => player.play());

  player.addEventListener('play', () => {
    play.hidden = true;
  });

  player.addEventListener('pause', () => {
    play.hidden = false;
  });
}

export function initVideoPlayers(
  parent = document,
  selector = '.js-video-player',
) {
  parent.querySelectorAll(selector).forEach((block) => initVideoPlayer(block));
}
